import type { Envs } from "~/types/envs";

export function useEnvironment(): Envs {
  const pageContext = usePageContext();

  return pageContext.envs;
}
